import { Navigate, useLocation } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';
// project import
import useSession from 'hooks/useSession';

// types
import { GuardProps } from 'model/types/auth';
import { APP_DEFAULT_PATH } from 'constants/appConstants';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: Readonly<GuardProps>) {
  const { status } = useSession();
  const location = useLocation();

  switch (status) {
    case 'booting':
    case 'attaching':
      return <Loader />;
    case 'anonymous':
      return children;
    case 'merchant-selection':
      return <Navigate to="/merchant-select" replace />;
    case 'active':
      return <Navigate to={location.state?.from || APP_DEFAULT_PATH} state={{ from: '' }} replace />;
  }
}
